import { useState } from "react";
import { ApiService } from "@src/shared/api/apiService";
import { API } from "./api";
import { initData } from "../const/initData";
import { ICandidate } from "@src/shared/types";
import { ICandidateResult } from "../types";

export const useSearchCandidateResult = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchCandidateResult, setSearchCandidateResult] =
    useState<ICandidate>(initData.candidate);

  const getSearchCandidateResult = async (
    request_uuid: string,
    candidate_id: string
  ) => {
    setIsLoading(true);
    try {
      const searchResultCandidateRes = await ApiService.get<ICandidateResult>(
        API.GET_COLD_MATCHING_RESULTS_BY_REQUEST_ID(request_uuid, candidate_id)
      );

      setSearchCandidateResult(
        searchResultCandidateRes.candidate || initData.candidate
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, getSearchCandidateResult, searchCandidateResult };
};
